import React from 'react'
import { Outlet } from 'react-router-dom'
import styled from 'styled-components'
import { Typography } from 'antd'
import LogoTuba from '@/assets/logoTuba'

const { Text } = Typography

const AuthContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: #e6ffff;
`

const ContentWrapper = styled.div`
  display: flex;
  width: 100%;
  max-width: 1200px;
  height: 80vh;
  padding: 20px;
  @media (max-width: 768px) {
    text-align: center;
  }
`

const IllustrationSection = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  position: relative;

  @media (max-width: 768px) {
    display: none;
  }
`

const FormSection = styled.div`
  flex: 0 0 500px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: white;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  @media (max-width: 768px) {
    flex: 1;
  }
`

const Logo = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 24px;

  img {
    width: 40px;
    height: 40px;
    margin-right: 10px;
  }
`

const LogoText = styled.span`
  font-size: 20px;
  font-weight: bold;
  color: #00a5a5;
`

const Copyright = styled.div`
  position: absolute;
  bottom: 20px;
  width: 100%;
  text-align: center;
`

const AuthLayout = () => {
  return (
    <AuthContainer>
      <ContentWrapper>
        <IllustrationSection>
          <img
            src="https://gw.alipayobjects.com/zos/rmsportal/TVYTbAXWheQpRcWDaDMu.svg"
            alt="Login illustration"
            style={{ maxWidth: '100%', maxHeight: '80vh' }}
          />
          <LogoTuba
            width="40vw"
            height="40vh"
            style={{
              position: 'absolute',
              top: '20%',
              left: '50%',
              transform: 'translateX(-50%)',
            }}
          />
        </IllustrationSection>
        <FormSection>
          <Logo>
            <LogoTuba width="5rem" height="5rem" />
            <LogoText>Tuba</LogoText>
          </Logo>
          <Outlet />
        </FormSection>
      </ContentWrapper>
      <Copyright>
        <Text type="secondary">Copyright © {new Date().getFullYear()} Tuba All right reserved</Text>
      </Copyright>
    </AuthContainer>
  )
}

export default AuthLayout
